import React from 'react';
import { PageWrapper } from '../../Styles/style';
import SmoothScroll from '../../Components/GsapSmoothScroll';
import CYAHeader from '../../Sections/CYA/S1-CYA';
import FooterCYA from '../../Sections/CYA/S2-Footer';
import LockerMenu from '../../Components/LockerMenu';
import PaymentHeader from '../../Sections/PaymentMethod/S1-Payment';


const Payemnt = () => {
  return (
    <PageWrapper>
        <LockerMenu/>
        <PaymentHeader/>
        <FooterCYA/>
    </PageWrapper>
   
  );
};

export default Payemnt;
